export default __webpack_public_path__ + "static/media/mascot 2.89a21a0d.png";